import {
  AzioniIstanzaSezioneDati,
  IstanzaSezioneDati,
} from '@framework/api-client';
import { FormValidatorBuilder } from '@framework/engine';
import { yup } from '@framework/validation';
import { mapDeclarationSections } from './mapDeclarationSections';

// const HTML_SIMPLE_REGEX = /(<([^>]+)>)/gi;

export function createDeclarationsSchema(
  declarations: AzioniIstanzaSezioneDati[] | null | undefined,
): yup.ObjectSchema<any> {
  if (!declarations) return yup.object().shape({}).required().noUnknown();

  const sections = mapDeclarationSections(declarations);

  const { schema } = FormValidatorBuilder.buildSections(sections);

  return schema;
}

/**
 * Recupera il prefisso da una dichiarazione da aggiungere al nome del campo,
 * e da usare come nome per l'oggetto dichiarazione nel validatore:
 *
 * {
 *  "dic_id": {"field1": ..., "field2": ...}
 * }
 *
 * <input name="dic_id.field1" />
 */
export function getFieldPrefix(
  declaration: IstanzaSezioneDati | null | undefined,
) {
  // TODO/FWP Ricontrollare, forse è `idIstanzaSezioneDati`?
  return declaration?.idSezioneDati;
}
